import React from 'react';
import { Row, Col } from 'reactstrap';

const DocumentsTab = () => {
  return (
    <Row>
      <Col md={12}>
        <div className="text-center p-4">
          <h5>Documents</h5>
          <p className="text-muted">Account documents content will be implemented here.</p>
        </div>
      </Col>
    </Row>
  );
};

export default DocumentsTab; 